<template>
  <div>
    <div class="add-user-info">
      <el-form label-position="top" :model="form" ref="form" :rules="rules">
        <el-form-item :label="$t('base_user_item_step_user.yuan_gong_bian_hao')">
          <el-input v-model="form.userCode" style="width: 280px"></el-input>
        </el-form-item>
        <el-form-item key="userName" :label="$t('base_user_item_step_user.yuan_gong_xing_ming')" prop="realName">
          <el-input v-model="form.realName" style="width: 280px"></el-input>
        </el-form-item>
        <el-form-item key="loginPwd" v-if="!userId" :label="$t('base_user_item_step_user.deng_lu_mi_ma')" prop="loginPwd">
          <el-input
            autocomplete="off"
            :readonly="inputReadonly"
            type="password"
            v-model="form.loginPwd"
            :placeholder="$t('base_user_item_step_user.mmcdw816wbszfhzmrylz')"
            style="width: 280px"
            :disabled="!!userId"
            @focus="inputReadonly = false"
          ></el-input>
        </el-form-item>
        <el-form-item key="mobile" :label="$t('base_user_item_step_user.lian_xi_dian_hua')" prop="mobile">
          <el-input v-model="form.mobile" style="width: 280px"></el-input>
        </el-form-item>
        <p style="line-height: 20px; font-size: 12px; color: #808080; margin-top: -18px">{{ $t('base_user_item_step_user.yyjsxtdxkdzzhyydl') }}</p>
        <el-form-item key="email" :label="$t('base_user_item_step_user.you_xiang')" prop="email">
          <el-input v-model="form.email" style="width: 280px"></el-input>
        </el-form-item>
        <p style="line-height: 20px; font-size: 12px; color: #808080; margin-top: -18px">{{ $t('base_user_item_step_user.yyxgmmkdzzhyydl') }}</p>
        <el-form-item key="langCode" :label="$t('base_user_item_step_user.mo_ren_yu_zhong')">
          <custom-select v-model="form.langCode" code="language_type" width="280px" :props="{ label: 'name', value: 'value' }"></custom-select>
        </el-form-item>
        <el-form-item key="timeZoneId" :label="$t('base_user_item_step_user.mo_ren_shi_qu')" v-if="timeZoneIdList.length > 1">
          <custom-select v-model="form.timeZoneId" url="timeZoneGetCompanyList" :params="{ orgId: orgId }" width="280px" :props="{ label: 'timeZoneRegionDesc', value: 'timeZoneId' }"></custom-select>
        </el-form-item>
        <el-form-item key="dateFormat" :label="$t('base_user_item_step_user.rqxsgs')">
          <custom-select v-model="form.dateFormat" code="bas_date_format" width="280px"></custom-select>
        </el-form-item>
        <el-form-item key="isTime24h" :label="$t('base_user_item_step_user.24xiao_shi_zhi')">
          <custom-select v-model="form.isTime24h" code="isynergy_cloud_bool" width="280px"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('base_user_item_step_user.yuan_gong_fen_zu')" prop="roleGroupCode" v-if="isHqAdmin && !orgId">
          <custom-select v-model="form.roleGroupCode" style="width: 280px" code="role_group_code" placeholder=""></custom-select>
          <!-- <custom-auto v-model="form.roleGroupCode" style="width: 280px" value-key="name" code="role_group_code" placeholder=""></custom-auto> -->
        </el-form-item>
      </el-form>
    </div>
    <div class="footer">
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="saveUser">{{ $t('base_user_item_step_user.xia_yi_bu') }}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    userId: [String, Number],
  },
  computed: {
    rules() {
      return {
        realName: [
          { required: true, message: this.$t('Common.com_required') },
          { max: 20, message: this.$t('Common.com_rules_length_max', [20]) },
        ],
        loginPwd: [
          {
            required: true,
            min: 8,
            max: 16,
            message: this.$t('base_user_item_step_user.mmcdw816wbszfhzmrylz'),
          },
          {
            validator: null,
            message: this.$t('base_user_item_step_user.bxbhszfhzmrylz'),
          },
        ],
        email: [
          {
            required: true,
            type: 'email',
            message: this.$t('base_user_item_step_user.yxgsbzq'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ],
        dateFormat: { required: true, message: this.$t('Common.com_required') },
      };
    },
    // 是否总部管理员
    isHqAdmin() {
      const userInfo = this.$store.state.userInfo || {};
      return userInfo.bizType === 'HQ' && userInfo.isAdmin === 1;
    },
  },
  data() {
    return {
      orgId: '',
      type: '', // 类型add、edit
      inputReadonly: true,
      timeZoneIdList: [],
      form: {
        roleGroupCode: '',
        userCode: '',
        realName: '',
        loginPwd: '',
        mobile: '',
        langCode: '',
        email: '',
        timeZoneId: '',
        dateFormat: '',
        isTime24h: '',
      },
    };
  },
  mounted: function () {
    this.type = this.getJump('userId') ? 'edit' : 'add';
    this.orgId = this.getJump('orgId');
    this.formRule();
    this.getUserDate();
    this.getTimeZoneIdList();
    this.getDictionary('language_type', (data) => {
      if (this.type === 'add') {
        this.form.langCode = data.language_type[0] && data.language_type[0]['value'];
      }
    });
  },
  methods: {
    getTimeZoneIdList: function () {
      this.$getJSON(apis.timeZoneGetCompanyList, { orgId: this.orgId }).then((res) => {
        this.timeZoneIdList = res.data;
      });
    },
    formRule: function () {
      // this.rules.userName[1].validator = (rule, value, callback) => {
      //   const reg = /^(?!^[\d]+$)(?!^[-]+$)(?!^[_]+$)(?!^[a-zA-Z]+$)[\w-]{4,20}$/;
      //   if (!reg.test(value.toString())) {
      //     callback(new Error());
      //   } else {
      //     callback();
      //   }
      // };
      this.rules.loginPwd[1].validator = (rule, value, callback) => {
        const reg = /(?!.*\s)(?!^[\u4e00-\u9fa5]+$)(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,16}$/;
        if (!reg.test(value.toString())) {
          callback(new Error());
        } else {
          callback();
        }
      };
      // this.rules.mobile.validator = this.$mobilePhoneValidator;
    },
    // 取消
    onCancel: function () {
      this.$emit('cancel');
    },
    // 下一步
    onStep: function (userId) {
      this.$emit('step', {
        name: 'user',
        userId: userId,
        realName: this.form.realName,
      });
    },
    // 获取用户信息
    getUserDate: function () {
      if (!this.userId) {
        return;
      }
      this.$getJSON(`${apis.User}/${this.userId}`).then((res) => {
        this.$setFormatData(this.form, res.data);
      });
    },
    // 确认保存用户
    saveUser: function () {
      this.form.mobile = this.form.mobile.replace(/\s+/g, '');
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        const regx = /^[0-9\-]{7,13}$/g;
        if (this.form.mobile && !regx.test(this.form.mobile)) {
          this.$message.error(this.$t('base_user_item_step_user.dhcdyz713gzf'));
          return;
        }
        if (this.type === 'add' && !this.userId) {
          this.saveAddUser();
        } else {
          this.saveEditUser();
        }
      });
    },
    // 保存新增用户
    saveAddUser: function () {
      this.form.orgId = this.orgId;
      this.$postJSON(apis.UserAdd, Object.assign({}, this.form, { loginPwd: this.encrypt(this.form.loginPwd) })).then((res) => {
        const userId = res.data || '';
        this.onStep(userId);
      });
    },
    // 保存编辑用户
    saveEditUser: function () {
      this.$postJSON(apis.UserUpdate, {
        orgId: this.orgId,
        userId: this.userId,
        roleGroupCode: this.form.roleGroupCode,
        realName: this.form.realName,
        userCode: this.form.userCode,
        mobile: this.form.mobile,
        sex: this.form.sex,
        langCode: this.form.langCode,
        email: this.form.email,
        timeZoneId: this.form.timeZoneId,
        dateFormat: this.form.dateFormat,
        isTime24h: this.form.isTime24h,
      }).then(() => {
        this.onStep(this.userId);
      });
    },
  },
};
</script>

<style lang="scss"></style>
